import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
const Subsection = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className="flex flex-col gap-2 p-5">{children}</div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default Subsection;